import axios from "axios";
import {GOOGLE_ANALYTICS_MECHIRON_ID,GOOGLE_ANALYTICS_ACE_ID,GOOGLE_ANALYTICS_MAKO_ID} from '../configs/configs'
import ReactGA from 'react-ga';

export const ApiGetWithHeader = async(url, headerParam) => {
    try {
        var res = await axios({
            method: 'get',
            url: url,
            headers: {'access-token': headerParam}
          })
        
        const { result, ok } = res.data
        if(ok) {
            return result
        }
    } catch(err) {
        console.log('Error has been occured in GET request',err)
        if(err) return undefined
    }
    
}

export const ApiGet = async(url, params = null) => {
    try {

        if(!params) {
            var res = await axios.get(url,{
                params
            })
        } else {
            var res = await axios.get(url)
        }
        
        const { result, ok } = res.data
        if(ok) {
            return result
        }
    } catch(err) {
        console.log('Error has been occured in GET request',err)
        if(err) return undefined
    }
}

export const ApiPostWithBody = async (url,body) => {
    try {
        const res = await axios({
            method: 'post',
            url: url,
            data: body
        })
        return res.data
    } catch(err) {
        console.log('Error has been occured in POST request',err)
        if(err) return undefined
    }
   
}

export const ApiPostWithHeaderToken = async (url,token,body = null) => {
    
    try {
        const res = await axios({
            method: 'post',
            url: url,
            headers: {'access-token': token},
            data:body
        })
        return res.data
    } catch(err) {
        console.log('Error has been occured in POST request',err)
        if(err) return undefined
    }
   
}

export const calculateTotalPrice = (product,room) => {

    let formula = product.qty_formula
    formula = formula.toString()
    formula = formula.replace(/x/gi, room.x);
    formula = formula.replace(/y/gi, room.y);
    formula = formula.replace(/z/gi, room.z);
    formula = eval(formula)


    let total
    if(product.only_work){
        total = formula * (calculatePrices(product,'work',{x:room.x,y:room.y,z:room.z}))
    } else {
        total = formula * (calculatePrices(product,'work',{x:room.x,y:room.y,z:room.z}) + calculatePrices(product,'product',{x:room.x,y:room.y,z:room.z}))
    }
    
    total = total * 1.17
    total = parseFloat(Math.round(total * 100) / 100)
    return total
}

export const CheckMobileOrTablet = () => {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export const stringAreaSwap = (areaString) => {
    let newString = areaString
    newString = newString.replace(/A190001/gi, 'צפון')
    newString = newString.replace(/A190002/gi, 'השרון')
    newString = newString.replace(/A190003/gi, 'מרכז')
    newString = newString.replace(/A190004/gi, 'השפלה')
    newString = newString.replace(/A190005/gi, 'דרום')
    newString = newString.replace(/;/gi, ', ')
    return newString
}

export const israeliPhoneValidation = (phone,required = false) => {
    let phoneString = String(phone)
    if(phoneString.length === 0 && !required)
    return ''
    if(!phone && required)
    return 'אנא הכנס מספר טלפון'
    if(phoneString.length < 10 || phoneString.substr(0,2) !== '05' )
    return 'מספר טלפון אינו תקין'
}


export const calculatePrices = (product,typeOfCalc = 'work',params = {x:100,y:100,z:100}) => {
    if(product.length === 0)return 0
    if(Object.keys(product).length === 0 && product.constructor === Object) return 0
    let checkIfFormulaWork = product.work_price
    let checkIfFormulaProduct = product.product_price

    checkIfFormulaWork = parseInt(checkIfFormulaWork) 
    checkIfFormulaProduct = parseInt(checkIfFormulaProduct) 
    
        
    if(typeOfCalc === 'work'){
        if(!Number.isNaN(checkIfFormulaWork)){
            let price = Number(product.work_price)
            return price
        }
        
    }
        
    if(typeOfCalc === 'product'){
        if(!Number.isNaN(checkIfFormulaProduct)){
            let price = Number(product.product_price)
            return price
        }
       
    }
    

    let condition = product.if_condition
    let TotalCostString = product.total_cost
   


    if(product.width && product.width !== 'N'){
        if(product.width === 'Y') {
            TotalCostString = TotalCostString.replace(/width/gi, params.z)
            condition = condition.replace(/width/gi, params.z)
        } else {
            TotalCostString = TotalCostString.replace(/width/gi, product.width)
            condition = condition.replace(/width/gi, product.width)
        }

    } else {
        if(TotalCostString != null) {
            TotalCostString = TotalCostString.replace(/width/gi, '1')
        } else {
            TotalCostString = '1'
        }
        if(condition != null) {
            condition = condition.replace(/width/gi, '1')
        } 
    }

    

    if(product.length && product.length !== 'N'){
        if(product.length === 'X') {
            TotalCostString = TotalCostString.replace(/length/gi, params.x)
            condition = condition.replace(/length/gi, params.x)
        } else {
            TotalCostString = TotalCostString.replace(/length/gi, product.length)
            condition = condition.replace(/length/gi, product.length)
        }

    } else {
        TotalCostString = TotalCostString.replace(/length/gi, '1')
        condition = condition.replace(/length/gi, '1')
    }

    if(product.height && product.height !== 'N'){
        if(product.height === 'Z') {
            TotalCostString = TotalCostString.replace(/height/gi, params.y)
            condition = condition.replace(/height/gi, params.y)
        } else {
            TotalCostString = TotalCostString.replace(/height/gi, product.height)
            condition = condition.replace(/height/gi, product.height)
        }
    } else {
        TotalCostString = TotalCostString.replace(/height/gi, '1')
        condition = condition.replace(/height/gi, '1')
    }

    if(product.var_cost) {
        TotalCostString = TotalCostString.replace(/var_cost/gi, product.var_cost)
    } else {
        console.log('unhandled error of no var_cost found from db')
    }

    if(product.fix_cost && product.fix_cost != null) {
        let stringFixCost = product.fix_cost.toString()
        TotalCostString = TotalCostString.replace(/fix cost/gi, stringFixCost)
    } else {
        TotalCostString = TotalCostString.replace(/fix cost/gi, '0')
    }

    if(product.convert) {
        let stringConvert = product.convert.toString()
        TotalCostString = TotalCostString.replace(/convert/gi, stringConvert)
    } else {
        console.log('unhandled error of no convert found from db')
    }
    //
    if(condition != null && condition){
        condition = eval(condition)
        condition = condition ? product.true_value : product.false_value
        condition = condition.toString()
    } else {
        condition = '0'
    }


    TotalCostString = TotalCostString.replace(/if/gi, condition)
    TotalCostString = eval(TotalCostString)

    if(typeOfCalc === 'work') {
        TotalCostString = TotalCostString*product.w_percent
        TotalCostString = TotalCostString.toFixed(2)
        TotalCostString = Number(TotalCostString)
        return TotalCostString
    } else if (typeOfCalc === 'product') {
        TotalCostString = TotalCostString*product.p_percent
        TotalCostString = TotalCostString.toFixed(2)
        TotalCostString = Number(TotalCostString)
        return TotalCostString
    }
    

}


export const calculateTotalBidValue = (roomsArray) => {
    let total = []
    let roomTotal = 0
    
    roomsArray.map(room => {
        roomTotal = 0
        room.products.map(product => {
        let formula = product.qty_formula
            formula = formula.toString()
            formula = formula.replace(/x/gi, room.x);
            formula = formula.replace(/y/gi, room.y);
            formula = formula.replace(/z/gi, room.z);
            formula = eval(formula)
            if(product.work_only) {
                let roomPrice = calculatePrices(product, 'work',{x:room.x,y:room.y,z:room.z})
                roomTotal = roomTotal + (formula * Number(roomPrice))
            } else {
                let roomPrice =  calculatePrices(product, 'work',{x:room.x,y:room.y,z:room.z}) + calculatePrices(product, 'product',{x:room.x,y:room.y,z:room.z})
                roomTotal = roomTotal + (formula * Number(roomPrice))
            }
            
        })
        roomTotal = roomTotal * 1.17
        roomTotal = parseFloat(Math.round(roomTotal * 100) / 100)
        total.push(roomTotal)
    })
    return total.reduce( (total, num)=>{return total + num},0 )
}

export const initializeGA = (typeOfMechiron) => {
    if(typeOfMechiron === 'ace') {
        ReactGA.initialize([
            {trackingId: GOOGLE_ANALYTICS_MECHIRON_ID, gaOptions: { name: 'trackerMechiron' }},
            {trackingId: GOOGLE_ANALYTICS_ACE_ID, gaOptions: { name: 'trackerAce' }} 
        ])
    } else if(typeOfMechiron === 'mako'){
        ReactGA.initialize([
            {trackingId: GOOGLE_ANALYTICS_MECHIRON_ID, gaOptions: { name: 'trackerMechiron' }},
            {trackingId: GOOGLE_ANALYTICS_MAKO_ID, gaOptions: { name: 'trackerMako' }} 
        ])
    } else {
        ReactGA.initialize(GOOGLE_ANALYTICS_MECHIRON_ID)
    }
}

export const sendGAEvent = (typeOfMechiron,eventCategory,eventAction) => {
    if(typeOfMechiron === 'ace')
    ReactGA.ga('trackerAce.send', {hitType: "event", eventCategory, eventAction});

    if(typeOfMechiron === 'mako')
    ReactGA.ga('trackerMako.send', {hitType: "event", eventCategory, eventAction});

    ReactGA.ga('trackerMechiron.send', {hitType: "event", eventCategory, eventAction});
}


export const calculateRoomPrice = (item) => {

    let totalRoomPrice = 0
    
    item.products.map(product =>{
        let formula = product.qty_formula
        formula = formula.toString()
        formula = formula.replace(/x/gi, item.x);
        formula = formula.replace(/y/gi, item.y);
        formula = formula.replace(/z/gi, item.z);
        formula = eval(formula)
        let total = 0

        if(product.only_work){
            total = formula * (calculatePrices(product,'work',{x:item.x,y:item.y,z:item.z}))
        } else {
            total = formula * (calculatePrices(product,'work',{x:item.x,y:item.y,z:item.z}) + calculatePrices(product,'product',{x:item.x,y:item.y,z:item.z}))
        }

        total = total * 1.17
        total = parseFloat(Math.round(total * 100) / 100)
        
        totalRoomPrice += total
    })

    return totalRoomPrice
}



export const CSVBuilder = (cart) => {
    let finalResult = []

    cart.map(item=>{

        let totalRoomPrice = 0
        finalResult.push({
            ['']:item.name,
            [' ']:calculateRoomPrice(item),
        })
        finalResult.push({
            ['']:'סעיף',
            [' ']:'תאור',
            ['  ']:'יחידה',
            ['   ']:'כמות',
            ['    ']:'מחיר יחידה',
            ['     ']:'מחיר עבודה',
            ['      ']:'סה״כ',
        })

        finalResult.push({})

        item.products.map(product=>{
            let productDataArray = []
            // product data push to array to init in xlsx
            productDataArray.push(product.pid_id,product.name.replace(/\"/g, "``") ,product.units)
            let formula = product.qty_formula
            formula = formula.toString()
            formula = formula.replace(/x/gi, item.x);
            formula = formula.replace(/y/gi, item.y);
            formula = formula.replace(/z/gi, item.z);
            formula = eval(formula)
            productDataArray.push(formula)
            let total = 0

            if(product.product_price){
                let prodPrice = calculatePrices(product,'product',{x:item.x,y:item.y,z:item.z})
                productDataArray.push(prodPrice)
            } else {
                productDataArray.push('0.00')
            }

            if(product.only_work){
                let workPrice = (calculatePrices(product,'work',{x:item.x,y:item.y,z:item.z}))
                productDataArray.push(workPrice)
                total = formula * (calculatePrices(product,'work',{x:item.x,y:item.y,z:item.z}))
            } else {
                let workPrice = (calculatePrices(product,'work',{x:item.x,y:item.y,z:item.z}))
                productDataArray.push(workPrice)
                total = formula * (calculatePrices(product,'work',{x:item.x,y:item.y,z:item.z}) + calculatePrices(product,'product',{x:item.x,y:item.y,z:item.z}))
            }


            
            total = total * 1.17
            total = parseFloat(Math.round(total * 100) / 100)
            
            productDataArray.push(total)
            totalRoomPrice += total

            finalResult.push({
                ['']:productDataArray[0],
                [' ']:productDataArray[1],
                ['  ']:productDataArray[2],
                ['   ']:productDataArray[3],
                ['    ']:productDataArray[4],
                ['     ']:productDataArray[5],
                ['      ']:productDataArray[6],
            })
           
        })

        finalResult.push({})

    })

    return finalResult

}